import { createAction, props } from '@ngrx/store';
// import { GridView } from '@shared/interfaces/grid-settings.interface';

interface GridView {
  id: string;
  name: string;
  columns: string[];
}

export const storeGridViews = createAction(
  '[Grid View] Store Grid Views',
  props<{ gridType: string; views: GridView[] }>(),
);

export const addGridView = createAction(
  '[Grid View] Add Grid View',
  props<{ gridType: string; view: GridView }>(),
);

export const deleteGridView = createAction(
  '[Grid View] Delete Grid View',
  props<{ gridType: string; viewId: string }>(),
);

export const updateGridView = createAction(
  '[Grid View] Update Grid View',
  props<{ gridType: string; view: GridView }>(),
);

export const setGridViewType = createAction(
  '[Grid View] Set Grid View Type',
  props<{ gridType: string }>(),
);
